import { createContext, PropsWithChildren, useContext } from 'react';
import createDevToolsClient, {
  DevToolsClient,
} from 'studio5/clients/dev-tools';

const DevToolsContext = createContext<DevToolsClient>({} as DevToolsClient);

export default function DevToolsProvider({
  children,
}: PropsWithChildren<unknown>) {
  const devToolsClient = createDevToolsClient();

  return (
    <DevToolsContext.Provider value={devToolsClient}>
      {children}
    </DevToolsContext.Provider>
  );
}

export function useDevTools() {
  return useContext(DevToolsContext);
}
